// extracted by css-extract-rspack-plugin
export default {"root":"DTGho","input":"WcEXn","error":"OBCEG"};